<template>
  <b-row>
    <b-col cols="2">
        <h6 style="margin-top: 0px; margin-bottom: 0px">{{ $t('Filter') }}</h6>
        <b-input-group>
            <b-form-input v-model="filter" :placeholder="$t('Type to Search')" @update="filterChanged"/>
              <b-input-group-append>
                <b-button :disabled="!filter" variant="success" size="sm" @click="filter = ''">{{ $t('Clear') }}</b-button>
            </b-input-group-append>
        </b-input-group>
    </b-col>

    <b-col cols="1.5" style="margin-right: 1%">
        <h6 style="margin-top: 0px; margin-bottom: 0px">{{ $t('Per page') }}</h6>
        <b-form-select :options="pageOptions" v-model="perPage" @change="paginationChanged"/>
    </b-col>

    <b-col cols="2.5" style="margin-right: 1%">
      <h6 style="margin-top: 0px; margin-bottom: 0px">{{ $t('Time interval') }}</h6>
      <b-row>
        <b-col>
          <b-form-input type=date v-model="dateStart" @change="onChangedDateStart"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input type=date v-model="dateEnd" @change="onChangedDateEnd"></b-form-input>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="1.5" style="margin-right: 1%">
      <h6 style="margin-top: 0px; margin-bottom: 0px">{{ $t('Time Span') }}</h6>
      <b-form-select v-model="selected" :options="optionsTime" class="mb-2"/>
    </b-col>

    <b-col v-if="filterOptions.isFilterGroup" cols="1.5" style="margin-right: 1%">
      <h6 style="margin-top: 0px; margin-bottom: 0px">{{ $t('Groups') }}</h6>
      <b-form-select v-model="selectGroup" :options="optionsGroup" class="mb-2">
        <template slot="first">
          <option :value=0>---</option>
        </template>
      </b-form-select>
    </b-col>

    <b-col cols="1.5" v-if="filterOptions.isFilterTypeDocuments" style="margin-right: 1%" md="auto">
      <h6 style="margin-top: 0px; margin-bottom: 0px">{{ $t('Type documents') }}</h6>
      <b-form-select v-model="selectTypeDocuments" :options="optionsDocuments" class="mb-2"/>
    </b-col>

    <b-col cols="1.5" v-if="filterOptions.isFilterTypeUsers" style="margin-right: 1%" md="auto">
      <h6 style="margin-top: 0px; margin-bottom: 0px">{{ $t('Type') }}</h6>
      <b-form-select v-model="selectTypeUsers" :options="optionsTypeUseres" class="mb-2"/>
    </b-col>

    <b-col cols="1.5" v-if="filterOptions.isFilterTypeTraffic" style="margin-right: 1%" md="auto">
      <h6 style="margin-top: 0px; margin-bottom: 0px">{{ $t('Type') }}</h6>
      <b-form-select v-model="selectTypeTraffic" :options="optionsTraffic" class="mb-2"/>
    </b-col>

    <b-col cols="1.5" v-if="filterOptions.isFilterCollector" style="margin-right: 1%">
      <h6 style="margin-top: 0px; margin-bottom: 0px">{{ $t('Traffic collector') }}</h6>
      <b-form-select v-model="selectCollector" :options="optionsCollector" class="mb-2"/>
    </b-col>

    <b-col cols="1.5" style="margin-top: 1rem" md="auto" class="pb-2">
      <b-button variant="success" @click="generate" :disabled="isGenerateDisabled">{{ $t('Generate') }}</b-button>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    filterOptions: {
      isFilterGroup: false,
      isFilterTypeTraffic: false,
      isFilterTypeDocuments: false,
      isFilterTypeUsers: false,
      isFilterCollector: false
    },
    isGenerateDisabled: false
  },
  data () {
    return {
      selectCollector: 0,
      selectTypeTraffic: 0,
      selectTypeUsers: 0,
      selectTypeDocuments: 1,
      selectGroup: 0,
      optionsCollector: [],
      filter: '',
      pageOptions: [20, 40, 60, 80, 100],
      perPage: 20,
      dateStart: Date('1969-01-01'),
      dateEnd: Date('2050-10-10'),
      selected: null,
      optionsTraffic: [
        { text: '---', value: 0 },
        { text: this.$i18n.t('Gruopped by hour'), value: 1 },
        { text: this.$i18n.t('Gruopped by day'), value: 2 },
        { text: this.$i18n.t('Gruopped by month'), value: 3 },
        { text: this.$i18n.t('Gruopped by IPv4'), value: 4 },
        { text: this.$i18n.t('Gruopped by group'), value: 5 },
        { text: this.$i18n.t('Gruopped by IPv6'), value: 6 }
      ],
      optionsDocuments: [
        { text: this.$i18n.t('Invoice'), value: 1 },
        { text: this.$i18n.t('VAT invoice'), value: 2 },
        { text: this.$i18n.t('Acceptance report'), value: 4 },
        { text: this.$i18n.t('Detail invoice'), value: 7 } ],
      optionsTime: [
        { text: this.$i18n.t('Current Day'), value: 0 },
        { text: this.$i18n.t('Current Week'), value: 1 },
        { text: this.$i18n.t('Current Month'), value: 2 },
        { text: this.$i18n.t('Current Year'), value: 3 },
        { text: this.$i18n.t('Manually'), value: 4 }
      ],
      optionsTypeUseres: [
        { text: this.$i18n.t('All'), value: 0 },
        { text: this.$i18n.t('Correction of invoice positions'), value: 1 },
        { text: this.$i18n.t('Balance correction'), value: 2 },
        { text: this.$i18n.t('Adding user'), value: 3 },
        { text: this.$i18n.t('Editing user'), value: 4 },
        { text: this.$i18n.t('Deleting user'), value: 5 },
        { text: this.$i18n.t('Adding IP Group'), value: 6 },
        { text: this.$i18n.t('Editing IP group'), value: 7 },
        { text: this.$i18n.t('Adding user group'), value: 8 },
        { text: this.$i18n.t('Deleting user group'), value: 9 },
        { text: this.$i18n.t('Editing user group'), value: 10 },
        { text: this.$i18n.t('Adding user to group'), value: 11 },
        { text: this.$i18n.t('Removing user from group'), value: 12 },
        { text: this.$i18n.t('Adding account'), value: 13 },
        { text: this.$i18n.t('Editing account'), value: 14 },
        { text: this.$i18n.t('Adding service'), value: 15 },
        { text: this.$i18n.t('Editing service'), value: 16 },
        { text: this.$i18n.t('Users group operations'), value: 17 },
        { text: this.$i18n.t('Adding tariff'), value: 18 },
        { text: this.$i18n.t('Editing tariff'), value: 19 },
        { text: this.$i18n.t('Deleting tariff'), value: 20 },
        { text: this.$i18n.t('Adding service to tariff'), value: 21 },
        { text: this.$i18n.t('Deleting service from tariff'), value: 22 },
        { text: this.$i18n.t('Unlinking tariff from account'), value: 23 },
        { text: this.$i18n.t('Linking tariff to account'), value: 24 },
        { text: this.$i18n.t('Adding additional settings parameter'), value: 25 },
        { text: this.$i18n.t('Editing additional settings parameter'), value: 26 },
        { text: this.$i18n.t('Deleting additional settings parameter'), value: 27 },
        { text: this.$i18n.t('Instant tariff change'), value: 28 },
        { text: this.$i18n.t('Policy change'), value: 29 },
        { text: this.$i18n.t('Additing technical parameter'), value: 30 },
        { text: this.$i18n.t('Editing technical parameter'), value: 31 },
        { text: this.$i18n.t('Deleting technical parameter'), value: 32 },
        { text: this.$i18n.t('Cost coefficient change'), value: 37 }
      ]
    }
  },
  watch: {
    selectGroup: function (val) {
      this.$emit('onChangedGroup', val)
    },
    selectTypeDocuments: function (val) {
      this.$emit('onChangedTypeDocuments', val)
    },
    selectTypeUsers: function (val) {
      this.$emit('onChangedTypeUsers', val)
    },
    selectTypeTraffic: function (val) {
      this.$emit('onChangedTypeTraffic', val)
    },
    selectCollector: function (val) {
      this.$emit('onChangedCollector', val)
    },
    selected: function (val) {
      var currentDate = moment()
      switch (val) {
        case 0 :
          this.dateStart = currentDate.format('YYYY-MM-DD')
          this.dateEnd = currentDate.subtract(-1, 'days').format('YYYY-MM-DD')
          break
        case 1 :
          this.dateStart = moment().startOf('isoweek').format('YYYY-MM-DD')
          this.dateEnd = moment().endOf('isoweek').subtract(-1, 'days').format('YYYY-MM-DD')
          break
        case 2 :
          this.dateStart = moment().startOf('month').format('YYYY-MM-DD')
          this.dateEnd = moment().endOf('month').subtract(-1, 'days').format('YYYY-MM-DD')
          break
        case 3 :
          this.dateStart = moment().startOf('year').format('YYYY-MM-DD')
          this.dateEnd = moment().endOf('year').subtract(-1, 'days').format('YYYY-MM-DD')
          break
        case 4 :
          this.dateStart = moment().calendar()
          this.dateEnd = moment().calendar()
      }

      this.$emit('onChangedDateStart', new Date(this.dateStart))
      this.$emit('onChangedDateEnd', new Date(this.dateEnd))
    }
  },
  methods: {
    async loadCollector () {
      await this.$store.dispatch('Settings/GET_COLLECTORS', this.getStore).then(response => {
        let optionsCollector = this.$store.getters['Settings/COLLECTORS']
        for (let el of optionsCollector) {
          let newEl = {
            value: 0,
            text: ''
          }
          newEl.value = el.id
          newEl.text = el.name + ' (' + el.comments + ')'
          this.optionsCollector.push(newEl)
        }
        let newEl = {
          value: 0,
          text: '---'
        }
        this.optionsCollector.push(newEl)
      })
    },
    filterChanged () {
      this.$emit('filterChanged', this.filter)
    },
    paginationChanged () {
      this.$emit('paginationChanged', this.perPage)
    },
    onChangedDateStart () {
      this.$emit('onChangedDateStart', new Date(this.dateStart))
    },
    onChangedDateEnd () {
      this.$emit('onChangedDateEnd', new Date(this.dateEnd))
    },
    generate () {
      this.$emit('generate')
    }
  },
  computed: {
    optionsGroup () {
      let tmp = []
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {
          value: 0,
          text: ''
        }
        newEl.value = el.group_id
        newEl.text = el.group_name
        tmp.push(newEl)
      }
      return tmp
    }
  },
  mounted () {
    this.$emit('onChangedDateStart', new Date(this.dateStart))
    this.$emit('onChangedDateEnd', new Date(this.dateEnd))
    if (this.filterOptions.isFilterGroup && this.$store.getters['Users/GROUPS'].length === 0) {
      this.$store.dispatch('Users/GET_GROUPS')
    }
    if (this.filterOptions.isFilterCollector) {
      this.loadCollector()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/ReportHeader.vue